import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  constructor(
    private _snackBar: MatSnackBar
  ) { }

  show(text: string, action: string, duration = 6000) {
    //Todo:Bruno change action to enumn and based of that show Toaster icon + correct color
    return this._snackBar.open(text, action, {
      duration
    });
  }

  showError(text: string) {
    //Todo:Bruno change action to enumn and based of that show Toaster icon + correct color
    return this._snackBar.open(text, 'Error', {
      duration: 6000, panelClass: 'error-toaster'
    });
  }

}
